import { render, staticRenderFns } from "./NormalSingle.vue?vue&type=template&id=3cdafbac&scoped=true&"
import script from "./NormalSingle.vue?vue&type=script&lang=js&"
export * from "./NormalSingle.vue?vue&type=script&lang=js&"
import style0 from "./NormalSingle.vue?vue&type=style&index=0&id=3cdafbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdafbac",
  null
  
)

export default component.exports